import { useCallback } from 'react';
import { createPortal } from 'react-dom';

import { useDrawer } from '@/hooks/useDrawer';
import { css } from '@/utils';
import { Icon } from '../Icon';
import styles from './styles.module.scss';

export const Drawer = () => {
  const drawerRoot = document.getElementById('drawer-root');
  const { isDrawerOpen, setIsDrawerOpen, drawerChild } = useDrawer();

  const handleCloseDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, [setIsDrawerOpen]);

  if (!drawerRoot) return null;

  return createPortal(
    <>
      <div
        className={css(styles.drawerOverlay, styles[isDrawerOpen ? 'visible' : 'hidden'])}
        onClick={handleCloseDrawer}
      />
      <div className={css(styles.drawerContainer, styles[isDrawerOpen ? 'open' : 'closed'])}>
        <div className={styles.drawerHeader}>
          <button onClick={handleCloseDrawer} className={styles.closeButton}>
            <Icon name='close' size={20} />
          </button>
        </div>

        <div className={styles.drawerContent}>{drawerChild}</div>
      </div>
    </>,
    drawerRoot
  );
};
